module.exports = __webpack_public_path__ + "img/bluestone.09671dfb.png";